document.addEventListener('DOMContentLoaded', function () {
  var calcBtn = document.getElementById('ula-calc-btn');
  if (!calcBtn) return;

  calcBtn.addEventListener('click', function () {
    var length = parseFloat(document.getElementById('ula-length').value);
    var width = parseFloat(document.getElementById('ula-width').value);
    var height = parseFloat(document.getElementById('ula-height').value);
    var lux = parseFloat(document.getElementById('ula-lux').value);
    var efficiency = parseFloat(document.getElementById('ula-efficiency').value);
    var power = parseFloat(document.getElementById('ula-power').value);
    var result = document.getElementById('ula-result');

    if (!length || !width || !height || !lux || !efficiency || !power) {
      result.innerHTML = '<h2>Your Result</h2><p>Please complete all fields before calculating.</p>';
      return;
    }

    var area = length * width;
    var totalLumensRequired = area * lux;
    var lumensPerFitting = power * efficiency;

    var utilizationFactor = 0.7;
    if (height <= 6) {
      utilizationFactor = 0.78;
    } else if (height <= 8) {
      utilizationFactor = 0.74;
    } else if (height <= 10) {
      utilizationFactor = 0.70;
    } else if (height <= 12) {
      utilizationFactor = 0.66;
    } else {
      utilizationFactor = 0.62;
    }

    var maintenanceFactor = 0.8;
    var fittings = totalLumensRequired / (lumensPerFitting * utilizationFactor * maintenanceFactor);
    fittings = Math.ceil(fittings);

    var spacing = Math.max(3.5, Math.min(8, height * 0.8));

    var recommendedPower = '';
    if (height <= 6) {
      recommendedPower = '60W–100W';
    } else if (height <= 8) {
      recommendedPower = '100W–150W';
    } else if (height <= 10) {
      recommendedPower = '150W–200W';
    } else if (height <= 12) {
      recommendedPower = '200W–240W';
    } else {
      recommendedPower = '240W–300W';
    }

    result.innerHTML =
      '<h2>Your Result</h2>' +
      '<div class="ula-result-box"><strong>Estimated Area</strong>' + area.toFixed(1) + ' m²</div>' +
      '<div class="ula-result-box"><strong>Recommended Quantity</strong>' + fittings + ' × ' + power + 'W LED High Bay Lights</div>' +
      '<div class="ula-result-box"><strong>Estimated Total Lumen Requirement</strong>' + Math.round(totalLumensRequired).toLocaleString() + ' lm</div>' +
      '<div class="ula-result-box"><strong>Approximate Spacing Suggestion</strong>About ' + spacing.toFixed(1) + ' m between fittings</div>' +
      '<div class="ula-result-box"><strong>Typical Recommended Wattage for ' + height.toFixed(1) + 'm Ceiling</strong>' + recommendedPower + '</div>' +
      '<p class="ula-small">This is a quick estimate for planning purposes. For warehouse lighting layouts, beam angle selection and project quotations, contact ULA1L for a professional recommendation.</p>';
  });
});